var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"toast",class:'toast ' + _vm.classes},[_c('div',{domProps:{"textContent":_vm._s(_vm.text)}}),_vm._v(" "),_c('ion-icon',{attrs:{"name":"close-circle-outline"},on:{"click":_vm.destroy}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }